import { render, staticRenderFns } from "./Endereco.vue?vue&type=template&id=742c8b56&scoped=true&"
import script from "./Endereco.vue?vue&type=script&lang=js&"
export * from "./Endereco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742c8b56",
  null
  
)

export default component.exports